import { render, staticRenderFns } from "./RefreshDocumentEditorModal.vue?vue&type=template&id=8324f098&scoped=true&"
import script from "./RefreshDocumentEditorModal.vue?vue&type=script&lang=js&"
export * from "./RefreshDocumentEditorModal.vue?vue&type=script&lang=js&"
import style0 from "./RefreshDocumentEditorModal.vue?vue&type=style&index=0&id=8324f098&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8324f098",
  null
  
)

export default component.exports